<template>
  <div class="game-dev-info">
    <p v-if="result">Game Result: {{ result }}</p>
    <p v-if="!bindFirestore">No BindFirestore</p>
    <p>Move Time {{ Number(moveTime).toFixed(1) }}s</p>
    <p>Time Offset {{ Number(firestoreTimeOffset).toFixed(1) }}s</p>
    <p v-if="whiteTimeOffset != null">
      White Time Offset {{ whiteTimeOffset.toFixed(1) }}s
    </p>
    <p v-if="blackTimeOffset != null">
      Black Time Offset {{ blackTimeOffset.toFixed(1) }}s
    </p>
  </div>
</template>

<script>
import firebase from "firebase/app";
import { cachedTimeOffset } from "@/utils/firebase-helper";
import { getCommencedAt } from "vue-chess-shared/utils/match-helper";

export default {
  name: "GameDevInfo",

  props: {
    gameData: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      moveTime: 0,
    };
  },

  computed: {
    match() {
      return this.gameData.match || {};
    },

    timeData() {
      return this.gameData.timeData || {};
    },

    result() {
      return this.match.result;
    },

    bindFirestore() {
      return this.gameData.bindFirestore;
    },

    firestoreTimeOffset() {
      return cachedTimeOffset();
    },

    whiteTimeOffset() {
      if (!this.timeData.white) return;
      return this.timeData.white.timeOffset;
    },

    blackTimeOffset() {
      if (!this.timeData.black) return;
      return this.timeData.black.timeOffset;
    },

    moves() {
      return this.gameData.movesStats || [];
    },

    lastMove() {
      return this.moves.at(-1);
    },
  },

  methods: {
    getMoveTime() {
      // No move yet
      if (!this.moves.length) {
        if (!this.match.startedAt) return -1; // match hasn't started yet
        return (
          firebase.firestore.Timestamp.fromDate(new Date()) -
          getCommencedAt(this.match, this.moves) +
          this.firestoreTimeOffset
        );
      }

      // Match finished
      if (this.match.endedAt) {
        return this.match.endedAt - this.lastMove.createdAt;
      }

      // new move created but firebase hasn't return createdAt yet
      if (!this.lastMove.createdAt) return 0;

      return (
        firebase.firestore.Timestamp.fromDate(new Date()) -
        (this.lastMove.receivedAt || this.lastMove.createdAt) +
        this.firestoreTimeOffset
      );
    },
  },

  created() {
    this.intervalId = setInterval(() => {
      const moveTime = this.getMoveTime();
      if (isNaN(moveTime)) {
        return 0;
      }
      this.moveTime = this.getMoveTime();
    }, 250);
  },

  beforeDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
  },
};
</script>

<style scoped>
.game-dev-info {
  text-align: right;
  color: grey;
  font-size: 12px;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 15px 15px 10px;
}
</style>
